import { render, staticRenderFns } from "./NovoProdutoModal.vue?vue&type=template&id=883d2502&scoped=true&"
import script from "./NovoProdutoModal.vue?vue&type=script&lang=js&"
export * from "./NovoProdutoModal.vue?vue&type=script&lang=js&"
import style0 from "./NovoProdutoModal.vue?vue&type=style&index=0&id=883d2502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883d2502",
  null
  
)

export default component.exports